function upload_new_image(sender) {
    var $ = jQuery.noConflict();
    var upload_max_mbs = 3;
    var elm = $(sender);
    var image_wrapper = false;
    if(elm.attr('data-image-container-key') != undefined) {
        image_wrapper = find_image_wrapper(elm, elm.attr('data-image-container-key'));
    }

    var uploaded_image = false;
    if (sender.files && sender.files[0]) {
        if(image_wrapper !== false) {
            image_wrapper.isLoading();
        }
        var FR= new FileReader();
        FR.onload = function(e) {
            if(elm[0].files[0].size <= (upload_max_mbs * 1000000)) {
                uploaded_image = new Image();
                var if_done_uploading_and_checking_sizes = function(result, sizes) {
                    if(elm.attr('data-name') != undefined) {
                        if(elm.next().attr('name') != elm.attr('data-name')) {
                            elm.after('<input type="hidden" name="'+elm.attr('data-name')+'" />');
                            elm.next().after('<input type="hidden" name="'+elm.attr('data-name')+'_sizes[]" />');
                            elm.next().after('<input type="hidden" name="'+elm.attr('data-name')+'_sizes[]" />');
                        }
                        elm.next().val(result);
                        elm.next().next().val(sizes[0]);
                        elm.next().next().next().val(sizes[1]);
                    }
                }
                if(image_wrapper !== false) {
                    image_wrapper.find('img').attr('src', e.target.result);

                    uploaded_image.onload = function() {
                        image_wrapper.find('.sizes-wrapper').html(uploaded_image.width+"x"+uploaded_image.height);
                        image_wrapper.doneLoading();
                        if_done_uploading_and_checking_sizes(e.target.result, [uploaded_image.width, uploaded_image.height]);
                    };

                } else {
                    uploaded_image.onload = function() {
                        if_done_uploading_and_checking_sizes(e.target.result, [uploaded_image.width, uploaded_image.height]);
                    };
                }
                uploaded_image.src = e.target.result;
            } else {
                squde_flash("Bestand overschrijdt de maximale bestandsgrootte van "+upload_max_mbs+"MB.", "alert");
                if(image_wrapper !== false) {
                    image_wrapper.doneLoading();
                }
            }
        };
        FR.readAsDataURL( sender.files[0] );
    }

    function find_image_wrapper(elm, key) {
        if(elm.parent().find('[data-'+key+']').length > 0) {
            return elm.parent().find('[data-'+key+']');
        }
        if(elm.parent().length == 0) {
            return false;
        }
        return find_image_wrapper(elm.parent(), key);
    }
    return false;
}